"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const IconArrow = () => {
    return (react_1.default.createElement("svg", { width: "28", height: "28", viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("circle", { cx: "14", cy: "14", r: "14", fill: "#F8B073" }),
        react_1.default.createElement("path", { d: "M10 18L18.2 9.80005M18.9999 13.83V9H14.1699", stroke: "#292D32", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = IconArrow;
